import { cn } from "../../../lib/cn";
import { Link } from "react-router-dom";

/**
 * PageHeader — unified page title section with breadcrumb, description, and actions.
 * Replaces repeated breadcrumb + h1 + action button patterns across pages.
 */
export const PageHeader = ({
  breadcrumbs = [],
  title,
  description,
  actions,
  className,
}) => {
  return (
    <div className={cn("flex flex-col gap-2 mb-6", className)}>
      {breadcrumbs.length > 0 && (
        <nav aria-label="Breadcrumb" className="flex items-center gap-2 text-sm">
          {breadcrumbs.map((crumb, index) => {
            const isLast = index === breadcrumbs.length - 1;
            return (
              <span key={index} className="flex items-center gap-2">
                {crumb.href && !isLast ? (
                  <Link
                    to={crumb.href}
                    className="text-mediumgrey hover:text-primary transition-colors"
                  >
                    {crumb.label}
                  </Link>
                ) : (
                  <span
                    className={isLast ? "text-darkgrey font-semibold" : "text-mediumgrey"}
                    aria-current={isLast ? "page" : undefined}
                  >
                    {crumb.label}
                  </span>
                )}
                {!isLast && <span className="text-mediumgrey">/</span>}
              </span>
            );
          })}
        </nav>
      )}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
        <div className="min-w-0">
          {title && (
            <h1 className="text-xl font-bold text-primary font-sans truncate">
              {title}
            </h1>
          )}
          {description && (
            <p className="text-sm text-mediumgrey mt-0.5">{description}</p>
          )}
        </div>
        {actions && (
          <div className="flex items-center gap-2 flex-shrink-0">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};
